import * as yup from "yup";

export const imprestValidation = yup.object().shape({
  date: yup.date().required("Date is required"),
  description: yup.string().required("Description is required"),
  amount: yup.number()
  .typeError('Invalid amount') // Shortened message for type error
  .positive('Must be positive') // Shortened message for positive number
  .min(0, 'Must be at least zero') // Shortened message for minimum value
  .required('Required') // Shortened message for required field
  .test('is-positive', 'Must be greater than zero', (value) => value > 0), // Custom test message,
});
